"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TenantSelectorComponent = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../../../containers/impact-dropdown/index"));

var _index2 = _interopRequireDefault(require("../../../containers/impact-button/index"));

var _rectangle = _interopRequireDefault(require("../../../../assets/img/rectangle.svg"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = {
  inputTnt: {
    margin: '0 0 1rem',
    height: '60px',
    maxWidth: '455px',
    backgroundColor: '#fff',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#e6e8ed',
    fontFamily: 'Open Sans,sans-serif',
    fontSize: '1.07143rem',
    letterSpacing: '.00429rem',
    color: '#888',
    width: '100%',
    padding: '14px 13px',
    borderRadius: 0,
    backgroundImage: "url(".concat(_rectangle.default, ")"),
    backgroundPosition: '109% -22px',
    backgroundSize: '17px 17px',
    backgroundRepeat: 'no-repeat',
    transition: 'background-position .4s ease',
    overflow: 'visible',
    lineHeight: '1.15',
    boxSizing: 'border-box',
    ':focus': {
      backgroundPosition: 'calc(100% - 5px) 5px',
      borderColor: '#888'
    }
  },
  changeModeLink: {
    WebkitAppearance: 'none',
    appearance: 'none',
    border: 'none',
    background: 'none',
    color: '#fff',
    textDecoration: 'underline',
    cursor: 'pointer',
    margin: '1rem 0 0',
    padding: '0'
  },
  errorMsg: {
    margin: '0.5rem 0',
    textAlign: 'center'
  }
};

var TenantSelectorList = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(TenantSelectorList, _React$PureComponent);

  var _super = _createSuper(TenantSelectorList);

  function TenantSelectorList() {
    (0, _classCallCheck2.default)(this, TenantSelectorList);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(TenantSelectorList, [{
    key: "render",
    value: function render() {
      var component = this;
      var tenantOptions = [];
      var selectedTenant;

      var _iterator = _createForOfIteratorHelper(this.props.tenants),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var value = _step.value;
          tenantOptions.push({
            value: value.tenantId,
            display: value.displayName
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (this.props.selectedTenant) {
        selectedTenant = this.props.selectedTenant.displayName;
      }

      function onChange(ev) {
        component.props.onChange(ev.target.value);
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        "data-selector": "tenant-selector"
      }, /*#__PURE__*/_react.default.createElement(_index.default, {
        onChange: onChange,
        options: tenantOptions,
        selected: selectedTenant,
        defaultLabel: 'Select Tenant...'
      }));
    }
  }]);
  return TenantSelectorList;
}(_react.default.PureComponent);

var TenantSelectorPrivate = /*#__PURE__*/function (_React$PureComponent2) {
  (0, _inherits2.default)(TenantSelectorPrivate, _React$PureComponent2);

  var _super2 = _createSuper(TenantSelectorPrivate);

  function TenantSelectorPrivate(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TenantSelectorPrivate);
    _this = _super2.call(this, props);
    _this.state = {
      tenantEntry: ''
    };
    return _this;
  }

  (0, _createClass2.default)(TenantSelectorPrivate, [{
    key: "renderErrors",
    value: function renderErrors() {
      if (!this.state.error) return /*#__PURE__*/_react.default.createElement("span", null);
      return /*#__PURE__*/_react.default.createElement("div", {
        style: styles.errorMsg,
        "data-selector": "mid-error"
      }, this.state.error);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          tenants = _this$props.tenants,
          onChange = _this$props.onChange,
          onChangeMode = _this$props.onChangeMode;
      var component = this;

      function setError(error) {
        component.setState({
          error: error
        });
      }

      function clearError() {
        component.setState({
          error: null
        });
      }

      function tryTenant() {
        var tenantName = component.state.tenantEntry;
        var tenant = tenants.find(function (tenant) {
          return tenant.displayName === tenantName;
        });

        if (tenant) {
          onChange(tenant.tenantId);
        } else {
          setError('Tenant unrecognized, try again');
        }
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        "data-selector": "tenant-selector-privacy"
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("input", {
        "data-selector": "mid-tenant",
        placeholder: "Tenant",
        type: "text",
        id: "tenant",
        autoComplete: "off",
        spellCheck: "false",
        style: styles.inputTnt,
        onChange: function onChange(ev) {
          return _this2.setState({
            tenantEntry: ev.target.value
          });
        },
        value: this.state.tenantEntry,
        onKeyPress: function onKeyPress(ev) {
          clearError();

          if (ev.key === 'Enter') {
            ev.preventDefault();
            tryTenant();
          }
        }
      })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_index2.default, {
        onClick: function onClick(ev) {
          ev.preventDefault();
          clearError();
          tryTenant();
        },
        defaultLabel: "Choose"
      })), this.renderErrors(), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement("button", {
        "data-selector": "tenant-selector-change-mode",
        onClick: function onClick(ev) {
          ev.preventDefault();
          clearError();
          onChangeMode('default');
        },
        style: styles.changeModeLink
      }, "Browse list instead")));
    }
  }]);
  return TenantSelectorPrivate;
}(_react.default.PureComponent);

var MODES = {
  default: TenantSelectorList,
  privacy: TenantSelectorPrivate
};

var TenantSelectorComponent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TenantSelectorComponent, _React$Component);

  var _super3 = _createSuper(TenantSelectorComponent);

  function TenantSelectorComponent(props) {
    var _this3;

    (0, _classCallCheck2.default)(this, TenantSelectorComponent);
    _this3 = _super3.call(this, props);
    _this3.state = _objectSpread(_objectSpread({}, props), {}, {
      selectedTenant: ''
    });
    var cls = _this3.state.cls;
    cls.tenantSelectorComponent = (0, _assertThisInitialized2.default)(_this3);
    return _this3;
  }

  (0, _createClass2.default)(TenantSelectorComponent, [{
    key: "getCurrentMode",
    value: function getCurrentMode() {
      return this.state.mode || this.props.mode || 'default';
    }
  }, {
    key: "sendSelectedTenantToLoginComponent",
    value: function sendSelectedTenantToLoginComponent(tenant) {
      this.state.sendTenant(tenant);
    }
  }, {
    key: "resetDisplaySelected",
    value: function resetDisplaySelected() {
      var _this4 = this;

      this.setState(function (prevState) {
        delete prevState.selectedTenant;

        _this4.state.resetDisplay();

        return _objectSpread({}, prevState);
      });
    }
  }, {
    key: "selectTenant",
    value: function selectTenant(tenantId) {
      var _this5 = this;

      this.setState(function (prevState, props) {
        var tenant = props.tenants.filter(function (e) {
          return e.tenantId === tenantId;
        }).pop();
        props.selectTenantResolver(tenant);

        _this5.sendSelectedTenantToLoginComponent(tenant);

        return _objectSpread(_objectSpread({}, prevState), {}, {
          selectedTenant: tenant
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var tenantOptions = [];
      var selectedTenant = '';

      if (this.props.tenants && this.props.tenants.length > 1) {
        var Component = MODES[this.getCurrentMode()] || MODES.default;
        return /*#__PURE__*/_react.default.createElement(Component, {
          tenants: this.props.tenants,
          onChange: function onChange(tenantId) {
            if (tenantId !== undefined) {
              _this6.selectTenant(tenantId);
            } else {
              _this6.resetDisplaySelected();
            }
          },
          onChangeMode: function onChangeMode(mode) {
            return _this6.setState({
              mode: mode
            });
          }
        });
      } else {
        return /*#__PURE__*/_react.default.createElement("div", null);
      }
    }
  }]);
  return TenantSelectorComponent;
}(_react.default.Component);

exports.TenantSelectorComponent = TenantSelectorComponent;
TenantSelectorComponent.propTypes = {
  tenants: _propTypes.default.array,
  selectTenantResolver: _propTypes.default.func,
  sendTenant: _propTypes.default.func,
  selectedTenant: _propTypes.default.object,
  resetDisplay: _propTypes.default.func,
  mode: _propTypes.default.oneOf(['default', 'privacy'])
};